import ArchiveIcon from '@mui/icons-material/Archive';
import ButtonWithSpinner from '../../../../components/buttons/ButtonWithSpinner';
import { flatten, unique } from '../../../../utils/ArrayUtils';
import './ArchiveSelectedLessons.scss';

import { filterUndefined } from '../../../../utils/FilterUndefinedObject';

const defaultProps = {
  lessons: [],
  archiveLessonFunction: () => { },
  isArchiving: false,
  selectedLessonIds: [],
};

const ArchiveSelectedLessons = (p) => {
  const { lessons, archiveLessonFunction, isArchiving, selectedLessonIds } = { ...defaultProps, ...filterUndefined(p) };
  const flattenLessons = unique(flatten(lessons.map((subjectWithLessons) => subjectWithLessons.lessons)), 'id');
  const activeLessons = flattenLessons.filter((lesson) => !lesson.meta.archived);

  const handleOnClick = async () => {
    const activeSelectedLessons = activeLessons.filter((lesson) => selectedLessonIds.includes(lesson.id));
    await archiveLessonFunction(activeSelectedLessons, true);
  };

  return (
    <ButtonWithSpinner
      label='Archive'
      className='btn-primary archive-selected-lessons-action'
      disabled={activeLessons.length === 0 || selectedLessonIds.length === 0 || isArchiving}
      loading={isArchiving}
      onClick={handleOnClick}
      startIcon={<ArchiveIcon />}
      data-test='archive-selected-lessons-action'
    />
  );
};

export default ArchiveSelectedLessons;
